import { atom } from "recoil"

export const designInitialLoadCompleteState = atom({
  key: `designInitialLoadComplete`,
  default: false,
})
